const it = {
    'Total': 'Totale',
    'Go to checkout': 'Vai alla cassa',
    'Coupon': 'Coupon',
    'Email': 'E-mail',
    'Proceed': 'Procedi all\'acquisto',
    'Select a shipping method to continue': 'Per proseguire seleziona il metodo di spedizione',
    'Name': 'Nome',
    'Last name': 'Cognome',
    'Street': 'Via',
    'Zip code': 'CAP',
    'City': 'Città',
    'Country': 'Paese',
    'State/Region': 'Provincia',
    'Change shipping address': 'Cambia indirizzo di spedizione',
    'Change billing address': 'Cambia indirizzo di fatturazione',
    'Change payment method': 'Cambia metodo di pagamento',
    'Edit': 'Modifica',
    'Select shipping method': 'Seleziona un metodo di spedizione',
    'Select payment method': 'Scegli una modalità di pagamento',
    'Additional services': 'Servizi aggiuntivi',
    'Apply': 'Applica',
    'Sign in': 'Accedi',
    'Password': 'Password',
    'I want to receive the <span>INVOICE</span>': 'Desidero ricevere la <span>FATTURA</span>',
    'Invoice requested': 'Fattura richiesta',
    'Fiscal code': 'Codice fiscale',
    'FC': 'CF',
    'Quantity': 'Quantità',
    'Loading': 'Caricamento',
    'Remove': 'Rimuovi',
    'Back': 'Indietro',
    '<strong>Add {tot}</strong> and we\'ll give you <strong>free</strong> shipping':
        '<strong>Aggiungi {tot}</strong> e ti <strong>regaliamo</strong> la spedizione',
    'Shipping informations': 'Informazioni di spedizione',
    'Shipping address': 'Indirizzo di spedizione',
    'Address': 'Indirizzo',
    'Company Name': 'Ragione Sociale',
    'VAT Number': 'Partita IVA',
    'PEC Address': 'Indirizzo PEC',
    'SDI Code': 'Codice SDI',
    'Are you sure you want to delete this item from cart?':
        'Sei sicuro di voler cancellare questo articolo dal carrello?',
    'Cart': 'Carrello',
    'Shipping': 'Spedizione',
    'Email and telephone number': 'E-mail e numero di telefono',
    'Billing address': 'Indirizzo di Fatturazione',
    'Billing address is the same as the shipping address': 'I dati di fatturazione e spedizione coincidono',
    'Selected address has invalid fields': 'L\'indirizzo selezionato contiene campi non validi',
    'Continue as guest': 'Prosegui come Guest',
    'or': 'oppure',
    'Recover password': 'Recupera la password',
    'Account creation': 'Creazione Account',
    'Continue': 'Continua',
    'Please wait': 'Attendere prego',
    'Close': 'Chiudi',
    'Order placed': 'Ordine effettuato. Stai per essere redirezionato alla pagina di riepilogo',
    'Send remainder': 'Invia email recupero password',
    'Password confirm': 'Conferma password',
    'Save address': 'Salva indirizzo',
    'Street number': 'Numero civico',
    'Select a payment method': 'Seleziona un metodo di pagamento',
    'Payment method': 'Metodo di pagamento',
    'Error during registration': 'Errore durante la registrazione',
    'We have sent you an email to reset your password. Click on the link you will find inside.':
        'Ti abbiamo inviato una mail per resettare la password. Clicca sul link che troverai al suo interno.',
    'Service unavailable, retry later': 'Errore temporaneo durante la richiesta, riprova tra breve',
    'Error, try to logout and login back to proceed with checkout': 'Errore, prova a disconnetterti e ad accedere nuovamente per procedere con il checkout',
    'Ordered products': 'Prodotti ordinati',
    'No shipping methods available': 'Nessun metodo di spedizione disponibile',
    'We\'re unable to send the password reset email':
        'Non è stato possibile inviare la mail di reset password. Controlla l\'email inserita',
    'Do you have a promotional code?': 'Hai un codice promozionale?',
    'Insert the code': 'Inserisci il codice',
    'Order summary': 'Riepilogo ordine',
    'VAT': 'IVA',
    'Sign up': 'Registrati',
    'Already registered on': 'Sei già registrata/o a',
    'Don\'t have an account yet?': 'Non hai ancora un account?',
    'First time on': 'La prima volta su',
    'Create your personal account.': 'Crea il tuo account personale.',
    'Your Password': 'La tua password',
    'Your name': 'Il tuo nome',
    'Your last name': 'Il tuo cognome',
    'Choose a password': 'Scegli una password',
    'Your email': 'Il tuo indirizzo email',
    'Or sign in with your email address': 'Oppure accedi col tuo indirizzo email',
    'Sign in with your email address': 'Accedi col tuo indirizzo email',
    'Do you already have an account?': 'Hai già un account?',
    'Create an account': 'Crea un account',
    'Sign up with your email address': 'Registrati con il tuo indirizzo email',
    'Continue shopping': 'Continua lo shopping',
    'Your cart is empty': 'Il tuo carrello è vuoto',
    'product': 'prodotto',
    'products': 'prodotti',
    'Shipping included': 'Spedizione inclusa',
    'Choose a shipping address': 'Scegli un indirizzo di spedizione',
    'There aren\'t shipping methods for this address, insert/select another one':
        'Non sono presenti metodi di spedizione per questo indirizzo, inseriscine/selezionane un altro',
    'Attention, the cost of shipments has been updated': 'Attenzione, il costo delle spedizioni è stato aggiornato',
    'Select an address': 'Seleziona un indirizzo',
    'Save new address to proceed': 'Salva il nuovo indirizzo per procedere',
    'Create new address to proceed': 'Crea un nuovo indirizzo per procedere',
    'Insert a valid email address to proceed': 'Inserisci un\'email valida per procedere',
    'Accept all agreements to proceed': 'Accettare i consensi per procedere',
    '<a href="{link}">Edit it</a> or insert/select another one':
        'Effettua la <a href="{link}">modifica</a> o inseriscine/selezionane un altro',
    'Phone number': 'Telefono cellulare',
    'Telephone number': 'Recapito telefonico',
    'Contact details': 'Dettagli di contatto',
    'Address details': 'Dettagli indirizzo',
    'Add new address': 'Aggiungi un nuovo indirizzo',
    'Enter Company Name': 'Inserisci la Ragione sociale',
    'Enter VAT Number': 'Inserisci la Partita IVA',
    'Enter PEC Address': 'Inserisci l\'email PEC',
    'Enter your SDI code': 'Inserisci il tuo codice SDI',
    'Please check your order.': 'Si prega di controllare l\'ordine.',
    'By confirming your order, you accept our general terms and conditions as well as the information on security and data protection on www.passionebeauty.com.':
        'Confermando l\'ordine, si accettano le nostre condizioni generali così come le informazioni sulla sicurezza e protezione dei dati del sito www.passionebeauty.com.',
    'Loading payment form, please wait': 'Caricamento del form di pagamento, attendere prego',
    'Available for shipment': 'Disponibile per la spedizione',
    'I understand': 'Ho capito',
    'Forgot Your Password?': 'Password dimenticata?',
    'Step {step} of {steps}': 'Step {step} di {steps}',
    'This field is mandatory': 'Questo campo è obbligatorio',
    'Enter at least one of the two fields': 'Inserire almeno uno dei due campi',
    'Sales conditions': 'Condizioni di vendita',
    'Ops! The payment for your last order <strong>was unsuccessful and will be automatically deleted within 20 minutes</strong>. To try again click below and the procedure will start again.':
        'Ops! Il pagamento del tuo ultimo ordine <strong>non è andato a buon fine e verrà automaticamente cancellato entro 20 minuti</strong>. Per riprovare clicca qui sotto e la procedura inizierà di nuovo.<br/><br/>Attenzione: se durante il tuo ordine hai provato ad usare una Gift Card, devi attendere la cancellazione dell\'ordine (20 minuti) prima di poterla riutilizzare.',
    'Do you prefer to return to visit the site and place your order later?':
        'Preferisci tornare a visitare il sito ed inserire il tuo ordine dopo?',
    'Reorder': 'Riordina',
    'Your last order has not been completed. If you want to add last order\'s items click on "Add" button':
        'Il tuo ordine precedente non è stato completato. Se vuoi aggiungere i prodotti dell\'ordine precedente clicca sul pulsante "Aggiungi"',
    'Add': 'Aggiungi',
    'Check the phone number: <strong>it must be a valid mobile phone</strong>.':
        'Verifica il numero di telefono: <strong>deve essere un telefono mobile italiano</strong>.',
    'Change telephone number': 'Cambia numero di telefono',
    'Telephone must be a valid italian mobile phone': 'Il telefono deve essere un telefono cellulare italiano valido',
    'Do you have a gift card?': 'Hai un codice gift card?',
    'Verify gift card': 'Verifica la gift card',
    'Current balance': 'Saldo corrente',
    'The gift card is invalid or empty. Please check the gift card and try again':
        'La gift card non è valida o è vuota. Controlla la gift card e riprova',
    'Gift card applied': 'Gift card aggiunta',
    'Gift card was removed because the total amount is too low':
        'Gift card rimossa perchè il suo valore supera l\'ammontare del carrello. Aggiungi altri prodotti per usare la giftcard',
    'No payment information required': 'Nessuna informazione di pagamento richiesta',
    'Sign in with {social}': 'Accedi con {social}',
    'Added to wishlist': 'Aggiunto alla wishlist',
    'Do you want to add the product to your wish list before removing it?':
        'Vuoi aggiungere il prodotto alla wishlist prima di rimuoverlo?',
    'Add to wishlist': 'Aggiungi alla wishlist',
    'Please note! One or more products cannot be ordered. Please check the products highlighted in red in your shopping cart.':
        'Attenzione! Uno o più prodotti non sono ordinabili. Si prega di controllare i prodotti evidenziati in rosso nel carrello.',
    'Payment': 'Pagamento',
    'Check': 'Verifica',
    'VAT {taxPercent}% included': 'IVA {taxPercent}% inclusa',
    'Sconto (Rimborso IVA)': 'Rimborso IVA',
    'Select': 'Seleziona',
    'Change': 'Modifica',
    'Pickup Point': 'Punto di ritiro',
    'Change pickup point': 'Cambia punto di ritiro',
    'You have selected a different country, please choose your prefered shipping method':
        'Hai selezionato un paese diverso, scegli il metodo di spedizione preferito',
    'Please enter your email address below to receive a password reset link.':
        'Inserisci il tuo indirizzo email qui sotto per ricevere un link di reimpostazione della password.',
    'To see your cart, first log in to your Passione Beauty account.':
        'Per vedere il tuo carrello accedi prima al tuo account Passione Beauty.',
    'If you need further assistance.': 'Se hai bisogno di ulteriore assistenza.',
    'Write to us': 'Scrivici',
    'Registration completed successfully': 'Registrazione effettuata con successo',
    'View and track order': 'Visualizza e traccia ordine',
    'By completing this order you can earn {points}': 'Completando questo ordine guadagni {points}',
    'If you are registered with the Passione Club, with this order you will get {points}':
        'Iscrivendoti al Passione Club con questo ordine otterrai {points}',
    '{points} - completing order': '{points} - completando l\'ordine',
    '{points} - bonus for in-app purchase': '{points} - bonus per acquisto da app',
    'Used up': 'Esaurito',
    'Sorry, we can\'t apply this service right now':
        'Siamo spiacenti ma al momento non possiamo applicare questo servizio',
    'Benefits have been reset, try to apply again': 'I benefit sono stati reimpostati, prova a riapplicarli',
    'There is already an account with this email address. If you are sure that it is your email address, <a href="{url}">click here</a> to get your password and access your account.':
        'Esiste già un account con questo indirizzo email. Se sei certo che sia il tuo indirizzo email, <a href="{url}"> clicca qui</a> per ottenere la password e accedere al tuo account.',
    'If you\'d like to use a Coupon, please remove the Gift Card first':
        'Se desideri utilizzare un Coupon, rimuovi prima la Gift Card',
    'Pay with a saved credit card': 'Paga con una carta di credito salvata',
    'Expiration': 'Scadenza',
    'Pay with a new credit or debit card': 'Paga con una nuova carta di credito o debito',
    'Save credit card (one click payment)': 'Salva carta di credito (pagamento con un clic)',
    'Sign up with {social}': 'Registrati con {social}',
    'Registering with Facebook is very fast. There is no need to remember other passwords - no commitments for the brain. Don\'t worry, we won\'t share any information about you and we won\'t post anything on your behalf.':
        'Registrarsi con Facebook è velocissimo. Non c\'è bisogno di ricordarsi altre password - niente impegni per il cervello. Non preoccuparti, non condivideremo nessuna informazione relativa a te e non pubblicheremo nulla per tuo conto.',
    'Shipping Country': 'Nazione di spedizione',
    'Removing': 'Rimozione',
    'Free shipping': 'Spedizione gratuita',
    'Save for future use': 'Salvare per uso futuro',
    'This order will be associated to your sales code:': 'Questo ordine sarà associato al tuo codice di vendita:',
    'Delete card': 'Elimina carta',
    'Card deleted.': 'Carta eliminata.',
    'Use another card or another payment method to continue.':
        "Utilizza un'altra carta oppure un altro metodo di pagamento per continuare.",
    'Try entering your card details again or use another payment method to continue.':
        'Prova ad inserire nuovamente i dati della carta oppure usa un altro metodo di pagamento per continuare.',
    'There was an error deleting your card, please try again later':
        'Si è verificato un errore durante l\'eliminazione della tua carta, riprova più tardi',
    'Or register with your e-mail address': 'Oppure registrati con il tuo indirizzo email',
    'ReCaptcha validation failed, please try again': 'La convalida ReCaptcha non è riuscita, riprova',
    'This site is protected by reCAPTCHA and the Google <a href="{privacyPolicyLink}">Privacy Policy</a> and <a href="{termsOfServiceLink}">Terms of Service</a> apply.':
        'Questo sito è protetto da reCAPTCHA e si applicano le <a href="{privacyPolicyLink}">Norme sulla privacy</a> e i <a href="{termsOfServiceLink}">Termini di servizio</a> di Google.',
    'Forgot Password?': 'Password dimenticata?',
    'Conditions of sale for training courses': 'Condizioni di vendita per i corsi di formazione',
    'Previously it was: {omnibusPrice} -{omnibusPercentage}':
        'Precedentemente era: {omnibusPrice} -{omnibusPercentage}',
    'How to read prices': 'Come leggere i prezzi',
    'Here is an example to understand what the prices you find mean':
        'qui un esempio per capire cosa significano i prezzi che trovi',
    'This is the original price of the item without discounts (list price)':
        'Questo è il prezzo originario dell\'articolo senza sconti (prezzo di listino)',
    'This is the currently active discount on the item applied to the list price price expressed as a percentage':
        'Questo è lo sconto attualmente attivo sull\'articolo applicato sul prezzo di listino espresso in percentuale',
    'This is the current item price with discount applied and VAT included':
        'Questo è il prezzo attuale dell\'articolo con sconto applicato e IVA inclusa',
    'This is the lowest price the item had in the last 30 days before it was discounted':
        'Questo è il prezzo più basso che ha avuto l\'articolo nei 30 giorni prima di essere scontato',
    'Telephone prefix': 'Prefisso telefonico',
    'Telephone without prefix': 'Telefono senza prefisso',
    'Choose whether you have a VAT number or are a small business':
        'Scegli se hai una partita IVA o sei una piccola impresa',
    'Card': 'Carta di credito',
};

export default it;
export const itValidation = {
    name: 'it',
    messages: {
        '_default': (e: any) => {
            return `Il valore del campo ${e} non è valido.`;
        },
        'after': (e: any, n: any) => {
            return `Il ${e} deve essere dopo ${n[0]}.`;
        },
        'alpha': (e: any) => {
            return `Il campo ${e} può contenere solo caratteri alfabetici.`;
        },
        'alpha_dash': (e: any) => {
            return `Il campo ${e} può contenere caratteri alfa-numerici così come lineette e trattini di sottolineatura.`;
        },
        'alpha_num': (e: any) => {
            return `Il campo ${e} può contenere solo caratteri alfanumerici.`;
        },
        'alpha_spaces': (e: any) => {
            return `Il campo ${e} può contenere solo caratteri alfanumerici così come spazi.`;
        },
        'before': (e: any, n: any) => {
            return `Il campo ${e} deve essere prima di ${n[0]}.`;
        },
        'between': (e: any, n: any) => {
            return `Il campo ${e} deve essere compreso tra ${n[0]} e ${n[1]}.`;
        },
        'confirmed': (e: any, n: any) => {
            return `Il campo ${e} non corrisponde con ${n[0]}.`;
        },
        'credit_card': (e: any) => {
            return `Il campo ${e} non è valido.`;
        },
        'date_between': (e: any, n: any) => {
            return `La ${e} deve essere compresa tra ${n[0]} e ${n[1]}.`;
        },
        'date_format': (e: any, n: any) => {
            return `La ${e} deve essere nel formato ${n[0]}.`;
        },
        'decimal': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-void, no-param-reassign
            void 0 === n && (n = []);
            let r = n[0];
            // eslint-disable-next-line no-return-assign
            return (
                // eslint-disable-next-line no-void
                void 0 === r && (r = '*'),
                    `Il campo ${e} deve essere numerico e può contenere${r && r !== '*' ? ` ${r}` : ''} punti decimali.`
            );
        },
        'digits': (e: any, n: any) => {
            return `Il campo ${e} deve essere numerico e contenere esattamente ${n[0]} cifre.`;
        },
        'dimensions': (e: any, n: any) => {
            return `Il campo ${e} deve essere ${n[0]} x ${n[1]}.`;
        },
        'email': (e: any) => {
            return `Il campo ${e} deve essere un indirizzo email valido.`;
        },
        'excluded': (e: any) => {
            return `Il campo ${e} deve avere un valore valido.`;
        },
        'ext': (e: any) => {
            return `Il campo ${e} deve essere un file valido.`;
        },
        'image': (e: any) => {
            return `Il campo ${e} deve essere un'immagine.`;
        },
        'included': (e: any) => {
            return `Il campo ${e} deve avere un valore valido.`;
        },
        'ip': (e: any) => {
            return `Il campo ${e} deve essere un indirizzo IP valido.`;
        },
        'length': (e: any, n: any) => {
            const r = n[0];
            const o = n[1];
            return o
                ? `La lunghezza del campo ${e} deve essere compreso tra ${r} e ${o}.`
                : `La lunghezza del campo ${e} deve essere ${r}.`;
        },
        'max': (e: any, n: any) => {
            return `Il campo ${e} non può essere più lungo di ${n[0]} caratteri.`;
        },
        'c': (e: any, n: any) => {
            return `Il campo ${e} deve essere minore o uguale a ${n[0]}`;
        },
        'mimes': (e: any) => {
            return `Il campo ${e} deve avere un tipo di file valido.`;
        },
        'min': (e: any, n: any) => {
            return `Il campo ${e} deve avere almeno ${n[0]} caratteri.`;
        },
        'min_value': (e: any, n: any) => {
            return `Il campo ${e} deve essere maggiore o uguale a ${n[0]}`;
        },
        'numeric': (e: any) => {
            return `Il campo ${e} può contenere solo caratteri numerici.`;
        },
        'regex': (e: any) => {
            return `Attenzione il campo ${e} non ha un formato valido.`;
        },
        'required': (e: any) => {
            return `Il campo ${e} è richiesto.`;
        },
        'size': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            return `Il campo ${e} deve essere inferiore a ${((e) => {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const n = 1024;
                // eslint-disable-next-line no-cond-assign, no-param-reassign
                const r = (e = Number(e) * n) === 0 ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / n ** r).toFixed(2));
                const v = 1 * f;
                return `${v.toFixed(2)} ${['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][r]}`;
            })(n[0])}.`;
        },
        'url': (e: any) => {
            return `Il campo ${e} non è un URL valido.`;
        },
        'validate-piva-cf': () => {
            return 'Partita IVA / Codice fiscale non valido.';
        },
        'validate-regionid': () => {
            return 'Il campo Provincia è richiesto.';
        },
        'validate-password-wf': () => {
            return 'La lunghezza minima di questo campo deve essere uguale o maggiore di {1} caratteri. Spazi iniziali e finali verranno ignorati. Verificare che ci siano almeno 2 delle seguenti 3 condizioni: almeno una maiuscola, almeno un numero, almeno un carattere speciale.';
        },
        'validate-password-wf-length': () => {
            return 'La lunghezza minima di questo campo deve essere uguale o maggiore di {1} caratteri. Spazi iniziali e finali verranno ignorati.';
        },
        'validate-password-wf-character': () => {
            return 'Verificare che ci siano almeno 2 delle seguenti 3 condizioni: almeno una maiuscola, almeno un numero, almeno un carattere speciale.';
        },
        'validate-length': (e: any) => {
            return `Attenzione il campo ${e} deve avere una lunghezza di {1} caratteri.`;
        },
        'validate-fiscal-code': () => {
            return 'Il codice fiscale deve essere lungo esattamente 11, 13 o 16 caratteri.';
        },
        'validate-telephone-without-prefix': () => {
            return 'Specifica un numero di telefono valido, non deve contenere il prefisso (ad es. +39).';
        },
        'validate-foreign-country-telephone-without-prefix': () => {
            return 'Specifica un numero di telefono valido, non deve contenere il prefisso (ad es. +39).';
        }
    },
    attributes: {}
};
